import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DocumentListDTO } from '../../../models/document';

@Injectable({ providedIn: 'root' })
export class DocumentsTabService {
  public reloadDocumentsTab = new EventEmitter();

  public droppedFile$ = new BehaviorSubject<File[] | null>(null);

  private documents$ = new BehaviorSubject<DocumentListDTO[]>([]);
  private caseId: string | null = null;

  public get documents() {
    return this.documents$.asObservable();
  }

  public get documentsValue(): DocumentListDTO[] {
    return this.documents$.value;
  }

  public get cachedCaseId(): string | null {
    return this.caseId;
  }

  public setDocuments(documents: DocumentListDTO[], caseId?: string) {
    this.documents$.next(documents);
    if (caseId !== undefined) {
      this.caseId = caseId;
    }
  }

  public clearCache() {
    this.documents$.next([]);
    this.caseId = null;
  }
}
